export default __webpack_public_path__ + "static/media/delete-black.f3ac292d.svg";